import React, { useState } from 'react';

// StockIndicator component as you provided
const StockIndicator = ({ currentStock, maxStock, reorderPoint }) => {
  const [isHovered, setIsHovered] = useState(false);

  const getStockLevel = () => {
    if (currentStock <= 0) {
      return 'Out of Stock';
    } else if (currentStock <= reorderPoint) {
      return 'Low Stock';
    } else {
      return 'In Stock';
    }
  };

  const getLevelClass = () => {
    const level = getStockLevel();
    if (level === 'Out of Stock') {
      return 'bg-red-500';
    } else if (level === 'Low Stock') {
      return 'bg-yellow-500';
    } else {
      return 'bg-green-500';
    }
  };

  const stockPercentage = Math.min(Math.round((currentStock / maxStock) * 100), 100);

  return (
    <div
      className="relative flex items-center"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={`w-3 h-3 rounded-full ${getLevelClass()}`}></div>
      {isHovered && (
        <div className="absolute left-5 bg-gray-800 white-text text-xs px-2 py-1 rounded z-10 whitespace-nowrap">
          {getStockLevel()} ({stockPercentage}%)
        </div>
      )}
    </div>
  );
};

export default StockIndicator;
